var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntervistatDnDIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 7,
    viewBox: "0 0 16 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.5C0.716667 6.5 0.479167 6.40417 0.2875 6.2125C0.0958333 6.02083 0 5.78333 0 5.5C0 5.21667 0.0958333 4.97917 0.2875 4.7875C0.479167 4.59583 0.716667 4.5 1 4.5H15C15.2833 4.5 15.5208 4.59583 15.7125 4.7875C15.9042 4.97917 16 5.21667 16 5.5C16 5.78333 15.9042 6.02083 15.7125 6.2125C15.5208 6.40417 15.2833 6.5 15 6.5H1ZM1 2.5C0.716667 2.5 0.479167 2.40417 0.2875 2.2125C0.0958333 2.02083 0 1.78333 0 1.5C0 1.21667 0.0958333 0.979167 0.2875 0.7875C0.479167 0.595833 0.716667 0.5 1 0.5H15C15.2833 0.5 15.5208 0.595833 15.7125 0.7875C15.9042 0.979167 16 1.21667 16 1.5C16 1.78333 15.9042 2.02083 15.7125 2.2125C15.5208 2.40417 15.2833 2.5 15 2.5H1Z",
    fill: "#323338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntervistatDnDIcon);
export default __webpack_public_path__ + "static/media/intervistat_DnD_icon.0600c8fd79cac80598199b9ef446950c.svg";
export { ForwardRef as ReactComponent };